import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import List from '@material-ui/core/List';
import Paper from '@material-ui/core/Paper';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';

import links from '../../data/links';
import Modal from './ConnectedModal';

const Root = styled(Paper)`
  width: 85vw !important;
  height: 85vw !important;
  display: flex !important;
  padding: 16px !important;
  max-width: 750px !important;
  max-height: 750px !important;
  flex-direction: column !important;
`;

const Scroll = styled(List)`
  flex: 1 !important;
  display: flex !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  align-self: stretch !important;
  flex-direction: column !important;
`;

const Title = styled(Typography)`
  padding: 16px !important;
`;

function RenderItem({ title, link }, index) {
  return (
    <ListItem key={index}>
      <ListItemText primary={title} secondary={
          <a href={link} target="_blank" rel="noopener noreferrer">
            {link}
          </a>
        } />
    </ListItem>
  );
}

RenderItem.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

function LinkList() {
  const items = Object.values(links).map(RenderItem);

  return (
    <Modal>
      <Root>
        <Title variant="h4" gutterBottom>
          Link List
        </Title>
        <Scroll>{items}</Scroll>
      </Root>
    </Modal>
  );
}

export default LinkList;
